module.exports = __webpack_public_path__ + "static/img/jiedan.7af383f7.jpeg";